"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Membership = exports.activeStatus = void 0;
const crypto_1 = require("@akord/crypto");
exports.activeStatus = ["ACCEPTED", "PENDING", "INVITED"];
class Membership extends crypto_1.Encryptable {
    constructor(membershipProto, keys) {
        super(keys, null);
        this.id = membershipProto.id;
        this.owner = membershipProto.owner;
        this.address = membershipProto.address;
        this.createdAt = membershipProto.createdAt;
        this.updatedAt = membershipProto.updatedAt;
        this.expiresAt = membershipProto.expiresAt;
        this.data = membershipProto.data;
        this.status = membershipProto.status;
        this.role = membershipProto.role;
        this.encPublicSigningKey = membershipProto.encPublicSigningKey;
        this.email = membershipProto.email;
        this.vaultId = membershipProto.vaultId;
        this.keys = membershipProto.keys;
        this.memberDetails = membershipProto.memberDetails;
        this.__public__ = membershipProto.__public__;
        this.__cloud__ = membershipProto.__cloud__;
    }
}
exports.Membership = Membership;
